<template>
  <ul
    v-if="isSocialLinklist"
    class="footer-linklist footer-linklist--social"
  >
    <li
      v-for="link of linklist.links"
      :key="link.handle"
      class="footer-linklist__item-wrapper"
    >
      <a
        :href="link.url"
        class="footer-linklist__item"
        :aria-label="link.title"
        :rel="isExternalLink(link.url) ? 'noopener noreferrer' : null"
        :target="isExternalLink(link.url) ? '_blank' : null"
        @click="handleLinkClick(link.title, link.url)"
      >
        <component
          :is="getSocialIconComponent(link.url)"
          v-if="getSocialIconComponent(link.url)"
        />

        <span
          v-else
          v-text="link.title"
        />
      </a>
    </li>
  </ul>
  <ul
    v-else
    class="footer-linklist"
  >
    <li
      v-for="link of linklist.links"
      :key="link.handle"
      class="footer-linklist__item-wrapper"
    >
      <a
        :href="link.url"
        class="footer-linklist__item"
        :rel="isExternalLink(link.url) ? 'noopener noreferrer' : null"
        :target="isExternalLink(link.url) ? '_blank' : null"
        @click="handleLinkClick(link.title, link.url)"
        v-text="link.title"
      />
    </li>

    <li
      v-if="linklist?.title.toLowerCase().includes('legal')"
      class="footer-linklist__item-wrapper"
    >
      <button
        class="ot-sdk-show-settings button button--reset text-body-s-regular"
        v-text="$string('general.site_footer.cookie_settings')"
      />
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Footer linklist (footer-linklist)
 * -----------------------------------------------------------------------------
 * A linklist's list of child links in the footer
 *
 * @param {Object} linklist - Shopify linklist data.
 *
 */

import IconFacebook from '~icons/social/facebook.svg'
import IconTwitter from '~icons/social/twitter.svg'
import IconInstagram from '~icons/social/instagram.svg'
import IconLinkedin from '~icons/social/linkedin.svg'
import IconPinterest from '~icons/social/pinterest.svg'
import { track } from '~/helpers/datalayer-actions'

export default {
  name: 'FooterLinklist',

  components: {
    IconFacebook,
    IconTwitter,
    IconInstagram,
    IconLinkedin,
    IconPinterest,
  },

  props: {
    linklist: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      socials: ['facebook', 'twitter', 'instagram', 'linkedin', 'pinterest'],
    }
  },

  computed: {

    /**
     * Whether or not the linklist is for social media links
     * @returns {Boolean}
     */
    isSocialLinklist() {
      return this.linklist?.title?.toLowerCase().includes('social')
    },
  },

  methods: {

    /**
     * Get icon component name using link url to match list of socials
     * @param {String} linkUrl - The url in linklist
     * @returns {String}
     */
    getSocialIconComponent(linkUrl) {
      const social = this.socials.find((_social) => linkUrl.includes(_social))

      return social ? `icon-${social}` : ''
    },

    /**
     * Return if URL is external by checking if it starts with a relative '/'.
     * @param {String} url - The url in linklist.
     * @returns {Boolean}
     */
    isExternalLink(url) {
      return !url.startsWith('/')
    },

    /**
     * Handle link tracking
     * @param {String} label
     * @param {String} url
     */
    handleLinkClick(label, url) {
      track({
        event: 'footer_link_click',
        label,
        url,
      })
    },
  },
}
</script>

<style lang="scss">
@import './footer-linklist';
</style>
